import { render, staticRenderFns } from "./ForgotPassword.vue?vue&type=template&id=1a58fa7c&scoped=true"
import script from "./ForgotPassword.vue?vue&type=script&lang=ts"
export * from "./ForgotPassword.vue?vue&type=script&lang=ts"
import style0 from "./ForgotPassword.vue?vue&type=style&index=0&id=1a58fa7c&prod&lang=scss"
import style1 from "./ForgotPassword.vue?vue&type=style&index=1&id=1a58fa7c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a58fa7c",
  null
  
)

export default component.exports